<template>
  <div class="notiForm">
    <el-form
      :model="notiFormItems"
      ref="notiFormItems"
      :hide-required-asterisk="true"
    >
      <el-form-item
        label="タイトル"
        prop="title"
        :rules="[
          {
            required: true,
            message: '入力が必要です。',
            trigger: 'blur'
          }
        ]"
      >
        <span class="requireMessage">※必須</span>
        <el-input v-model="notiFormItems.title"></el-input>
      </el-form-item>
      <el-form-item
        label="メッセージ"
        prop="body"
        :rules="[
          {
            required: true,
            message: '入力が必要です。',
            trigger: 'blur'
          }
        ]"
      >
        <span style="padding-left:0.5rem" class="requireMessage">※必須</span>
        <el-input type="textarea" v-model="notiFormItems.body"></el-input>
      </el-form-item>
      <el-form-item id="form-footer">
        <el-button @click="onCancel()">キャンセル</el-button>
        <el-button type="primary" @click="_onClickSaveNotification()"
          >送信する</el-button
        >
      </el-form-item>
    </el-form>
    <div id="NotiRequest">
      <el-dialog :visible.sync="saveNotificationDialog" width="40%">
        <p class="dialogText">お知らせを送信しますか？</p>
        <span>
          <el-button id="btn-text" @click="saveNotificationDialog = false"
            >キャンセル</el-button
          >
        </span>
        <span>
          <el-button class="blue-text" @click="saveNotification()"
            >はい</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import UsecaseFactory from "@/usecases/usecase.factory.js";
const notificationUsecase = UsecaseFactory.create("notification");

export default {
  components: {},
  data () {
    return {
      notiFormItems: {
        title: "",
        body: "",
      },
      saveNotificationDialog: false,
    };
  },
  async created () {},
  methods: {
    _onClickSaveNotification () {
      this.$refs["notiFormItems"].validate(valid => {
        if (valid) {
          this.saveNotificationDialog = true;
        }
      });
    },
    onCancel () {
      const { $router } = this;
      $router.push("/admin/notifications");
    },
    async saveNotification () {
      const result = await notificationUsecase.createNotification({
        title: this.notiFormItems.title,
        body: this.notiFormItems.body,
      });
      if (result.data) {
        const { $router } = this;
        $router.push("/admin/notifications");
        this.$notify({
          title: "お知らせを送信しました。",
          duration: 3000,
        });
        return;
      }
      this.$notify({
        title: "お知らせ送信に失敗しました。再度お試しください",
        duration: 3000,
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

.notiForm {
  margin-left: 5%;
  margin-top: 3%;
}
#notiBtn {
  margin-left: 22%;
}
.notiForm .el-input__inner {
  width: 70% !important;
}
.notiForm .el-textarea__inner {
  width: 70% !important;
  height: 300px;
}
#btn-text {
  width: 50%;
  color: $text-lighter;
}
.dialogText {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3.5rem !important;
}
#form-footer {
  padding-top: 1rem;
}
.blue-text {
  width: 50%;
  color: $blue-extra-deep;
}
#NotiRequest .el-button {
  border: none;
}
.requireMessage {
  padding-left: 1.4rem;
  color: $red-base;
}
</style>
